import React, { useState } from "react";
import type { AutoSuggestValue } from "types/autoSuggestValue";
import { Tag } from "components/ui";
import { useFilter } from "hooks/filter";

export default function AutoSuggestDropdown(props: {
  values: AutoSuggestValue[];
  onClose: () => void;
  focusRef: React.RefObject<HTMLAnchorElement>;
}) {
  const { searchDispatch } = useFilter();
  let refs: React.RefObject<HTMLAnchorElement>[] = [];
  let [currentFocus, setCurrentFocus] = useState<number>(0);

  function submitSearchCriteria(value: AutoSuggestValue) {
    searchDispatch({
      type: "ADD_FILTER",
      payload: {
        criteria: value.searchCriteria,
        propertyCriteria: value.propertyCriteria,
        value: value.value,
        overwrite: false,
        label: value.label
          ? value.label
          : value.propertyCriteria
          ? value.label
          : value.labelValue.toString(),
      },
    });
    props.onClose();
  }

  function handleKeyPress(e: React.KeyboardEvent, value: AutoSuggestValue) {
    if (e.code === "ArrowDown") {
      e.preventDefault();
      const nextFocus = currentFocus + 1 === refs.length ? 0 : currentFocus + 1;
      refs[nextFocus].current?.focus();
      setCurrentFocus(nextFocus);
    } else if (e.code === "ArrowUp") {
      e.preventDefault();
      const prevFocus = (currentFocus === 0 ? refs.length : currentFocus) - 1;
      refs[prevFocus].current?.focus();
      setCurrentFocus(prevFocus);
    }
  }

  return (
    <div className="dropdown-content">
      {props.values.map((value, i) => {
        refs[i] = i === 0 ? props.focusRef : React.createRef();
        return (
          <a
            href={`#${value.value}`}
            ref={refs[i]}
            onFocus={() => setCurrentFocus(i)}
            className="dropdown-item is-clickable"
            tabIndex={0}
            key={`${value.label}${value.value}`}
            onClick={(e) => {
              e.preventDefault();
              submitSearchCriteria(value);
            }}
            onKeyDown={(e) => handleKeyPress(e, value)}
          >
            <Tag>{value.label}</Tag>
            <span className="push-left-xxs">{value.labelValue}</span>
          </a>
        );
      })}
    </div>
  );
}
